const severityFactors = [
    {severity: 4, factorFrom: 4},
    {severity: 3, factorFrom: 3, factorTo: 4},
    {severity: 2, factorFrom: 2, factorTo: 3},
    {severity: 1, factorFrom: 1, factorTo: 2}
]

export function getOutlierSeverity(outlierToCheck, percentThreshold) {
    const match = severityFactors.find(({factorFrom, factorTo}) =>
        outlierToCheck >= factorFrom * percentThreshold
        && (factorTo === undefined || outlierToCheck < factorTo * percentThreshold));
    return match ? match.severity : null;
}

export function getStyleForOutlierFunction(dataSelection, percentThreshold) {
    return (possiblyFoundOutlier) => {
        if (possiblyFoundOutlier) {
            const severity = getOutlierSeverity(possiblyFoundOutlier[dataSelection.diffKey], percentThreshold);
            return severity ? `outlier-severity-${severity}` : 'not-outlier';
        }
        return undefined;
    };
}
